import type {ReactElement} from 'react';
import {useState} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import type {ResponsivePreviewSwitchProps} from '@Components/event-wizard/responsive-preview-switch/responsive-preview-switch.types';
import styles from './responsive-preview-switch.module.scss';

export function ResponsivePreviewSwitch({onChange, isMobileSelected = true}: ResponsivePreviewSwitchProps): ReactElement<any> {
  const [isMobile, setIsMobile] = useState(isMobileSelected);

  const toggleMobileView = (): void => {
    setIsMobile(!isMobile);
    onChange();
  };

  return (
    <div className={`${styles.container} flex-row-align-center border-s-standard bg-neutral-0 shadow-static-elevation-2 spacing-p-2`}>
      <Icon
        onClick={toggleMobileView}
        isSelected={!isMobile}
        className="spacing-m-r-2 bg-primary-10"
        icon="icon-desktop"
        size={IconSize.SIZE_ICON_16}
        type={IconType.GHOST}
        shape={IconShape.CIRCLE}
        isUsedAsButton
      />
      <Icon isSelected={isMobile} onClick={toggleMobileView} icon="icon-mobile" size={IconSize.SIZE_ICON_16} type={IconType.GHOST} shape={IconShape.CIRCLE} isUsedAsButton />
    </div>
  );
}
